import { z } from 'zod';

export const contactFormSchema = z.object({
	contact_name: z.string().min(2, 'Naam is verplicht'),
	contact_email: z.string().email('Ongeldig e-mailadres'),
	contact_phone: z.string().min(10, 'Vul een geldig telefoonnummer in'),
	preferred_date: z
		.string()
		.optional()
		.refine(
			(val) => {
				if (!val) return true;
				const date = new Date(val);
				const today = new Date();
				today.setHours(0, 0, 0, 0);
				
return date >= today;
			},
			{ message: 'Datum mag niet in het verleden liggen' },
		)
		.refine(
			(val) => {
				if (!val) return true;
				const date = new Date(val);
				const day = date.getDay();
				
return day !== 0 && day !== 6;
			},
			{ message: 'Kies een doordeweekse dag (geen weekend)' },
		),
	preferred_time_slot: z.enum(['ochtend', 'middag']).optional(),
	interest: z.string().optional(),
	privacy_agreed: z
		.boolean()
		.refine((val) => val === true, { message: 'U moet akkoord gaan met de privacyverklaring' }),
	token: z.string().optional(),
});

export type ContactFormSchema = z.infer<typeof contactFormSchema>;
